import { create } from "zustand";
import { CardStatus, UserCard } from "../api/types";
import { useSDKConfigStore } from "./sdkConfigStore";

interface CardStatusState {
  status: CardStatus | null;
  userCard: UserCard | null;
  isUserCardDelegated: boolean;
  isLoading: boolean;
  error: string | null;
  // Internal methods for SDK use only
  _setCardStatus: (status: CardStatus, userCard: UserCard | null) => void;
  _setUserStatus: (status: CardStatus) => void;
  _setLoading: (loading: boolean) => void;
  _setError: (error: string | null) => void;
  _reset: () => void;
}

// Helper function to check if card is delegated to the current EOA
const isCardDelegatedToCurrentEOA = (userCard: UserCard | null): boolean => {
  if (!userCard) return false;

  // Get current EOA from global config store
  const { eoaAddress } = useSDKConfigStore.getState();
  if (!eoaAddress) return false;

  // Card is delegated to this EOA if holdingAddress matches the current EOA
  return userCard.holdingAddress.toLowerCase() === eoaAddress.toLowerCase();
};

export const useCardStatusStore = create<CardStatusState>((set) => ({
  status: null,
  userCard: null,
  isLoading: false,
  error: null,
  isUserCardDelegated: false,

  // Internal methods for SDK use only (prefixed with _)
  _setCardStatus: (status, userCard) => {
    const isCardDelegated = isCardDelegatedToCurrentEOA(userCard);
    set({
      status,
      userCard,
      isUserCardDelegated: isCardDelegated,
    });
  },

  _setLoading: (loading) => set({ isLoading: loading }),
  _setUserStatus: (status) => set({ status }),

  _setError: (error) => set({ error }),

  _reset: () =>
    set({
      status: null,
      userCard: null,
      isUserCardDelegated: false,
      isLoading: false,
      error: null,
    }),
}));
